var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-row",
        _vm._l(_vm.summaryTickets, function(ticket, ticketKey) {
          return _c(
            "v-col",
            { key: ticketKey, attrs: { cols: "12", sm: "3" } },
            [
              _c(
                "v-skeleton-loader",
                {
                  staticClass: "mx-auto",
                  attrs: {
                    type: "image",
                    height: "110",
                    loading: _vm.isLoading
                  }
                },
                [
                  _c("v-hover", {
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(ref) {
                            var hover = ref.hover
                            return [
                              _c(
                                "v-card",
                                {
                                  staticClass:
                                    "borderbox pa-4 pt-2 elevation-2 white pull-up summary-tickets",
                                  class: ticket.class,
                                  attrs: { height: "105px" }
                                },
                                [
                                  _c(
                                    "h4",
                                    {
                                      staticClass:
                                        "font-weight-light gray summary-tickets--title text-uppercase"
                                    },
                                    [_vm._v(" " + _vm._s(ticket.title) + " ")]
                                  ),
                                  !hover
                                    ? _c(
                                        "b",
                                        {
                                          staticClass:
                                            "display-2 d-flex justify-end"
                                        },
                                        [_vm._v(_vm._s(ticket.count))]
                                      )
                                    : _vm._e(),
                                  !hover
                                    ? _c("v-progress-linear", {
                                        class: ticket.class,
                                        attrs: {
                                          value:
                                            (ticket.count * 100) /
                                            _vm.summaryTickets[3].count,
                                          "background-opacity": "0.2",
                                          rounded: "",
                                          height: "5",
                                          color: "none"
                                        }
                                      })
                                    : _vm._e(),
                                  hover
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "d-flex transition-fast-in-fast-out v-card--reveal summary-ticket--description",
                                          staticStyle: { height: "100%" }
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.descriptions[ticketKey]
                                              ) +
                                              " "
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      true
                    )
                  })
                ],
                1
              )
            ],
            1
          )
        }),
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }